import { render } from "@testing-library/react";
import React, { Component } from "react";
import styled, { withTheme } from "styled-components";
import { Link } from "react-router-dom";
import Intl from "../common/Intl";
import { ifProp, theme, withProp } from 'styled-tools';
// images
import Cricket from "../../images/cricket_icon.png";
import Football from "../../images/football_icon.png";
import Tennis from "../../images/tennis_icon.png";
// import Emblem from "../../images/Emblem.png";
// import IplImage from 'src/images/iplCupIcon.png';
// import SpecialmarketNewIcon from "../../images/SpecialMarket.png";
import BlueRightBackground from "../../images/Rectangle932.png";
// import FacebookIcon from "../../images/Facebook_icon.png";
// import TelegramIcon from "../../images/Telegram_icon.png";
// import InstIcon from "../../images/Instagram_icon.png";
// import TwitterIcon from "../../images/Twitter_icon.png";
// import YoutubeIcon from "../../images/Youtube_icon.png";
// import AppDownloadIcon from "../../images/Download_icon.png";
import InplayLogo from "../../images/infinite1.png";
// import VectorBar from "../../images/Vectorbar.png";
// import IexchQRCode from "src/images/s3folder/iexchQRcode.png";
// import BigBashIcon from '../../images/bigbashicon.png';
// import PSL from '../../images/PSL-Mega-Menu.png';
import config from "src/config/config";
import { withAppContext } from "src/store/initAppContext";
import { CRMClickSMIcon } from "src/util/crmUtil";

const specialMarket = `${'/static/media/splMarket.png'}`

// const VolleyBall = `${'/static/media/volleyballicon.png'}`

const TopGames = (props: any) => {
  const { theme, app: { brandId, memberId } } = props
  const { config: { showAppDownload = true, showjoshlogo } } = theme;

  return (
    <Container>
      <div className="gamesleft">
        <Sub1>
          <h3>
            <Intl langKey="LOGIN@TOPGAMES" />
          </h3>
        </Sub1>

        <Link to={{ pathname: "/betting-exchange/:0" }}>
          <Sub2>
            <div className="sub2wrap">
              <img src={`${config.imageS3Host}${InplayLogo}`} alt="InplayLogo" />
              <p>
                <Intl langKey="LOGIN@INPLAYGAMES" />
              </p>
              {/* <Link to={{ pathname: '/sports' }}>In Play Games</Link> */}
            </div>
          </Sub2>
        </Link>

        <Link to={{ pathname: "/betting-exchange/online-cricket-betting" }}>
          <Sub2>
            <div className="sub2wrap">
              <img src={`${config.imageS3Host}${Cricket}`} alt="Cricket" />
              <p>
                <Intl langKey="SPORT@CRICKET" />
              </p>
            </div>
          </Sub2>
        </Link>

        <Link to={{ pathname: "/betting-exchange/football-betting" }}>
          <Sub2>
            <div className="sub2wrap">
              <img src={`${config.imageS3Host}${Football}`} alt="Football" />
              <p>
                <Intl langKey="SPORT@FOOTBALL" />
              </p>
            </div>
          </Sub2>
        </Link>

        <Link to={{ pathname: "/betting-exchange/tennis-betting" }}>
          <Sub2>
            <div className="sub2wrap">
              <img src={`${config.imageS3Host}${Tennis}`} alt="Tennis" />
              <p>
                <Intl langKey="SPORT@TENNIS" />
              </p>
            </div>
          </Sub2>
        </Link>

        {/* 
        <Link to={{ pathname: "/specialMarket" }}>
          <Sub2>
            <div className="sub2wrap">
              <img src={`${config.imageS3Host}${SpecialmarketNewIcon}`} />
              <p>
                <Intl langKey="TITLE@POLITICS" />
              </p>
            </div>
          </Sub2>
        </Link> */}


        <Link to={{ pathname: "/specialMarket" }}>
          <Sub2  className="ribbon">
            <div className="sub2wrap">
              <img src={`${config.imageV3Host}${specialMarket}`} alt="specialMarket" />
              <p className="width">
                <Intl langKey="TITLE@SPECIALEVENT" />
              </p>
            </div>
          </Sub2>
        </Link>

        {/* <Link to={{ pathname: "/market/100/-1/244539/1" }}>
          <Sub2>
            <div className="sub2wrap">
              <img src={`${config.imageS3Host}${SpecialmarketNewIcon}`} />
              <p>
                <Intl langKey="TITLE@HUNDRED"/>
              </p>
            </div>
          </Sub2>
        </Link> */}

        {/* <Link to={{ pathname: '/market/100/-1/41195/1' }}>
          <Sub2>
            <div className="sub2wrap">
              <img src={IplImage} />
              <p><Intl langKey="SUBMENU@IPLCUP2022" /></p>
            </div>
          </Sub2>
        </Link> */}

      </div>
      <div className="gamesright">
        <Sub7>
          <div className="sub7wrap">
            {/* <Link><img src={FacebookIcon} /></Link>
            <Link src="https://www.instagram.com/" ><img src={InstIcon} /></Link> */}
            <a onClick={() => CRMClickSMIcon(brandId, memberId, 'Facebook')} href={brandId == 33 || brandId == 34 ? "https://www.facebook.com/iw247official" : 
            (brandId == 39 || brandId == 40) ? 'https://www.facebook.com/fomo7.comofficial' : 
            (brandId == 46 || brandId == 47) ? 'https://www.facebook.com/Fun88India' : 
            'https://www.facebook.com/yolo247in'} rel="noreferrer" target="_blank">
              <img src={`${config.imageV3Host}/static/media/FacebookIcon.svg`} alt="FacebookIcon" />
            </a>
            {showjoshlogo && <a onClick={() => CRMClickSMIcon(brandId, memberId, 'Myjosh')} href={brandId == 33 || brandId == 34 ? 'https://share.myjosh.in/profile/3059c2d0-b9c1-4eed-b493-8b57ae397fe1?u=0x264dd8e597944a86' : (brandId == 39 || brandId == 40) ? 'https://share.myjosh.in/profile/a42d070d-0361-4c36-8049-343c9b1ce5d5?u=0x6fd11362a1c063fe' : 'https://share.myjosh.in/profile/e8aa1ac4-1807-40cf-b237-8af587fea618?u=0x66048681f02789dc'} rel="noreferrer" target="_blank">
              <img src={`${config.imageV3Host}/static/media/joshAppIcon.png`} alt="myjosh Ico" />
            </a>}

            <a onClick={() => CRMClickSMIcon(brandId, memberId, 'Instagram')} href={brandId == 33 || brandId == 34 ? "https://www.instagram.com/iw247official/" : 
            (brandId == 39 || brandId == 40) ? 'https://www.instagram.com/fomo7_com?igsh=MW90czJkOTl5NXZ4Nw==' : 
            (brandId == 46 || brandId == 47) ? 'https://www.instagram.com/fun88indofficial/' : 
            'https://www.instagram.com/yolo247_in'} rel="noreferrer" target="_blank">
              <img src={`${config.imageV3Host}/static/media/InstIcon.svg`} alt="instagram" />
            </a>

            <a onClick={() => CRMClickSMIcon(brandId, memberId, 'Twitter')} href={brandId == 33 || brandId == 34 ? "https://x.com/iw247official" : 
            (brandId == 39 || brandId == 40) ? 'https://x.com/FOMO7official' : 
            (brandId == 46 || brandId == 47) ? 'https://x.com/Fun88India' : 
            'https://twitter.com/Yolo247Official'} rel="noreferrer" target="_blank">
              <img src={`${config.imageV3Host}/static/media/TwitterIcon.svg`} alt="TwitterIcon" />
            </a>

            <a onClick={() => CRMClickSMIcon(brandId, memberId, 'Youtube')} href={brandId == 33 || brandId == 34 ? "https://www.youtube.com/@iW247Official" : 
            (brandId == 39 || brandId == 40) ? 'https://www.youtube.com/channel/UCt4FXXC494EcHrA6wtnqcng' : 
            (brandId == 46 || brandId == 47) ? 'https://www.youtube.com/@fun88india' : 
            'https://www.youtube.com/@yolo247.official/'} rel="noreferrer" target="_blank">
              <img src={`${config.imageV3Host}/static/media/YoutubeIcon.svg`} />
            </a>

            <a onClick={() => CRMClickSMIcon(brandId, memberId, 'Telegram')} href={brandId == 33 || brandId == 34 ? "https://t.me/Baaziadda" : 
            (brandId == 39 || brandId == 40) ? 'https://t.me/fomo7official' : 
            (brandId == 46 || brandId == 47) ? 'https://t.me/fun88indiachannel' : 
            'https://t.me/Yolo247'} rel="noreferrer" target="_blank">
              <img src={`${config.imageV3Host}/static/media/TelegramIcon.svg`} alt="TelegramIcon" />
            </a>

            <a onClick={() => CRMClickSMIcon(brandId, memberId, 'Whatsup')} href={brandId == 33 || brandId == 34 ? "https://whatsapp.com/channel/0029VayYatB11ulOO5EOw830" : 
            (brandId == 39 || brandId == 40) ? 'https://whatsapp.com/channel/0029Vaj0hwb30LKXnWS0de0g' : 
            (brandId == 46 || brandId == 47) ? 'https://whatsapp.com/channel/0029VaXc6B0BKfhw2Fo7UH0Q' : 
            'https://whatsapp.com/channel/0029VanJL8D5EjxyYpKdI11r'} rel="noreferrer" target="_blank">
              <img src={`${config.imageV3Host}/static/media/whatsApp_icon_desk.png`} alt="WhatsupIcon" />
            </a>
            

            {showAppDownload && <Link to="/" className="sub7wraplast">
              <img src={`${config.imageV3Host}/static/media/appDwnldIcon.svg`} alt="appDwnldIcon" />

              <p><Intl langKey="TopGames@DownloadAPP" /></p>
              <AppDownloadWrapp>
               <img src={`${config.imageV3Host}/static/cashsite/${theme.image.AppQrCode}`} alt="AppQrCode" />
                <h4>
                  <Intl langKey="APP@SCANQR" />
                </h4>
              </AppDownloadWrapp>
            </Link>}

          </div>
        </Sub7>
      </div>
    </Container>
  );
};

export default withTheme(withAppContext(TopGames));

const AppDownloadWrapp = styled.div`
  display: none;
  text-align: center;


  h4 {
    color: ${theme('palette.topGamesAppDwnldActiveText')};
    font-size: 14px;
    font-weight: bold;
    margin: 0;
  }
    
`;

const Container = styled.div`
  width: 100%;
  //  padding-top:20px;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  background: ${theme('palette.TopGamesContainerBg')};
  padding: 5px 0px;
  box-shadow: ${theme('palette.TopGamesContainerBoxShadow')};
  // overflow: hidden;

  /* .ribbon{

    ::before{
      content: '';
      position: absolute;
      background-image: url(${config.imageV3Host}/static/cashsite/${theme('image.eleribbon')});
      background-repeat: no-repeat;
      width: 83.575px;
    height: 78px;
    top: -20px;
    background-size: contain;
    left: -23px;
    }

  } */

  .gamesleft {
    width: 85%;
    display: flex;
    align-items: center;
    flex-direction: row;
    padding-right: 10px;
  }

  .gamesright {
    width: 26%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${theme('palette.TopGamesGamesRightBg')};
    position: relative;
    margin-left: 20px;

    :after {
      content: "";
      width: 30px;
      height: 100%;
      background: ${theme('palette.TopGamesGamesRightBg')};
      position: absolute;
      top: 0;
      left: -19px;
      border-bottom-left-radius: 10px;
      border-top-left-radius: 10px;
      transform: skew(-340deg);
    }
  }

  a {
    width: 25%;
  }
`;

const Sub1 = styled.div`
  // width: 342px;
  width: 400px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 56px;
  background: ${theme('palette.homeTopGamesBg')};
  transform: skew(-340deg);
  border-radius: 10px;

  :before {
    content: "";
    width: 24px;
    height: 56px;
    background: ${theme('palette.homeTopGamesBg-before')};
    transform: skew(340deg);
  }

  h3 {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0px;
    text-transform: uppercase;
    color: ${theme('palette.homeTopGamesTittle')};
    font-size: 20px;
    font-weight: bold;
    transform: skew(340deg);
    // padding-left: 14px;
  }
`;

export const Sub2 = styled.div`
  // width: 195px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 56px;
  background: ${theme('palette.topGamesSectionGamesBg')};
  /* background: ${theme('palette.topGamesSectionGamesBg')}; */
  /* background: ${theme('palette.topGamesSectionGamesBgHover')}; */
  /* box-shadow: 4px 0px 4px rgba(0, 0, 0, 0.25); */
  transform: skew(-340deg);
  margin-left: 14px;
  border-radius: 10px;
  overflow: hidden;

  .width{
    width: 33%;
  }

  :hover {
    /* background: ${theme('palette.topGamesSectionGamesBgHover')}; */
  
    background: ${theme('palette.topGamesSectionGamesBgHover')};
    transition: 0.3s ease-in;
    cursor: pointer;
  }

  :hover p {
    font-weight: bold;
    color: ${theme('palette.topGamesTabColorHover')};
  }

  img {
    width: 30px;
  }

  p {
    font-size: 13px;
    color: ${theme('palette.topGamesTabColor')};
    margin: 0px;
    padding-left: 5px;
  }

  .sub2wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    flex-direction: row;
    height: 50px;
    transform: skew(340deg);

    a {
      color: #fff;
    }
  }
`;

const Sub7 = styled.div`
  display: flex;
  align-items: center;
  background-repeat: no-repeat;
  height: 57px;
  background-size: cover;

  span {
    font-size: 13px;
    color: white;
    width: 50px;
  }

  .sub7wrap {
    width: auto;
    display: flex;
    align-items: center;
    justify-content: center;

    a {
      width: 27px;
      height: 27px;
      margin: 0px 5px;
      display: flex;
      z-index: 1;

      img {
        // width: 100%;
        width: 27px;
        border-radius: 20px;
      }
    }

    p {
    font-size: 13px;
    color: #fff;
    margin: 0px;
    padding-left: 5px;
    
    }

    .sub7wraplast {
      width: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      flex-direction: row;
      height: 50px;
      position: relative;
      margin: 0px 5px;
      padding: 0px 8px;
    
      a {
        color: #fff;
      }

      p {
        font-size: 11px;
        color: ${theme('palette.topGamesAppDwnldColor')};
        margin: 0px;
        padding-left: 5px;
      }

      p:hover {
        color: ${theme('palette.topGamesAppDwnldColorHover')};
      }

      :before {
        content: "";
        width: 1px;
        background: ${theme('palette.topGamesAppDwnldLeftLine')};
        display: flex;
        position: absolute;
        left: 0px;
        top: 0;
        bottom: 0;
      }

      :hover {
        ${AppDownloadWrapp} {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          width: 170px;
          padding: 10px;
          background-color: ${theme('palette.AppDownloadWrappScannerBg')};
          box-shadow: 0px -5px 8px rgb(0 0 0 / 60%);
          border: ${theme('palette.AppDownloadWrappScannerBorder')};
          border-radius: 5px;
          position: absolute;
          top: 50px;
          right: 0;
          z-index: 9;
          transition: 0.5s ease;
          cursor: initial;
          z-index: 999999;

          img {
            width: 150px;
          }
        }
      }
    }
  }
`;
